module.exports = __webpack_public_path__ + "img/01.2bbf24f2.png";